<template>
<div class="salesmanmycard">
<XR-head titleText="我的名片" :rightShow="false" ref="headObj"></XR-head>
<div id="content" class="shop-spread">
  <div class="main">
    <div class="bgimg">
      <!--<img src="/static/openSalesmanShop/qrcodebg.jpg" class="bg">-->
      <img class="bg" v-if="memberInfo.user_name" :src="MOBILE_URL+'/QRCode.aspx?isbg=1&val=' + MOBILE_URL + '/H5Recommend.aspx?source_username=' + memberInfo.user_name" alt="扫一扫二维码" />
    </div>
  </div>
  <XR-toast ref="XRtoast"></XR-toast> 
</div> 
</div>
</template>

<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data () {
    return {
      bottomPopup: false,
      memberInfo:{"user_name":""},      
      siteInfo: {},
      shareTitle:'旭日购商城',
      shareDesc:'',
      shareLinkUrl:'',
      shareImgUrl:'https://imgserver.xurigo.com/upload/images/product/2021/07/26/09441530f0733e-2841-4320-acb7-7266c3a3f5d1.png',
    }
  },
  mounted(){
      this.getSiteInfo()
      this.getIndexInfo()
    },  
  methods: {
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    open (position) {
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    },
    getIndexInfo(){      
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
      .then(function(res) {
        if (res.IsSuccess) {    
          if(res.Data.UserBs == 0){
            ths.$router.push('/openSalesmanShop')
            return;
          }
          ths.getMemberInfo()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getMemberInfo(){      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.$refs.XRtoast.hide()
          ths.initShare(res.Data.user_name);
          ths.memberInfo=res.Data
        }
      });      
    },
    initShare(username){
      var ths = this;
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            ths.shareLinkUrl = "https://m.xurigo.com/H5Recommend.aspx?source_username=" + username;
            wx.ready(function () {              
                wx.onMenuShareTimeline({
                    title: ths.shareTitle, // 分享标题
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareQQ({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareQZone({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
      });
    },
  }
}
</script>

<style>
body .salesmanmycard{
  display:block;
  width:100vw;
  height:100vh;
  background: #dd1112;
}
.salesmanmycard .main{
  display:flex;
  align-items:flex-start;
  justify-items:center;
  justify-content:center;
  width:100vw;
  height:calc(100vh - 56px);
}
.salesmanmycard .bgimg{
  display:block;
  position:relative;
  width:100vw;
  height:177.8125vw;
}
.salesmanmycard .bg{
  display:block;
  width:100vw;
  height:177.8125vw;
}
.salesmanmycard .img{
  display:block;
  position:absolute;
  top:70.9375vw;
  left:27.1vw;
  z-index:100;
  width:48.515625vw;
  height:48.515625vw;
  background:#000;
}
</style>


// WEBPACK FOOTER //
// src/pages/salesman/mycard.vue